export const GET_WARNINGS = "GET_WARNINGS";
export const GET_WARNING_CONFIGS = "GET_WARNING_CONFIGS";
export const GET_DASHBOARD_WARN_EVENTS = "GET_DASHBOARD_WARN_EVENTS";
export const GET_DASHBOARD_INFO = "GET_DASHBOARD_INFO";
export const CREATE_OR_UPDATE_WARNING = "CREATE_OR_UPDATE_WARNING";
export const GET_OPERATION_GUIDANCE_MANUALS = "GET_OPERATION_GUIDANCE_MANUALS";
export const UPDATE_OPERATION_GUIDANCE_MANUALs = "UPDATE_OPERATION_GUIDANCE_MANUAL";
